import { Component, OnInit , AfterViewInit } from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router';
import {DataService} from '../data.service';
import {environment} from '../../environments/environment.prod'
import {Meta,Title,SafeUrl,DomSanitizer} from '@angular/platform-browser';
import{HomeComponent} from '../home/home.component';

declare var $:any;

@Component({
  selector: 'app-all-modules',
  templateUrl: './all-modules.component.html',
  styleUrls: ['./all-modules.component.css']
})
export class AllModulesComponent implements OnInit,AfterViewInit {
  moduleTitle:string="";
  moduleData:any[]=[];
  userId:number=-1;
  imgPath:string="";
  moduleId:number=-1;
  type:string="";
  isLink:boolean=true;
  isShareMenu:boolean=false;
  shareUrl:string="";
  arr=Array;
  myurl:string="whatsapp://send?text=http://happcoach.com/PilotServices/Module/"+this.moduleId+".html";
  isLoading:boolean=true;
  noModules:boolean=false;
  userTypeId:number=-1;
  planId:number=-1;
  isNext:boolean=false;
  freeTag:boolean=false;

  constructor(
    private route:ActivatedRoute,
    private router:Router,
    private service:DataService,
    private title:Title,
    private meta:Meta,
    private sanitizer:DomSanitizer,
    private home:HomeComponent) {}

    ngOnInit() {
      this.service.watchStorage().subscribe(()=>{
        this.route.params.subscribe(params=>{
          this.moduleTitle=params['type'];
          this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"));
          this.getDashBoardModule(this.moduleTitle);
        });
      })
      this.route.params.subscribe(params=>{
        this.moduleTitle=params['type'];

      });
      this.title.setTitle("StratGist | "+this.moduleTitle+" Modules");
      this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"));
      this.getDashBoardModule(this.moduleTitle);
      this.imgPath=environment.imagePath;
      this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
      this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
    }

    ngAfterViewInit(){
      $(window).scrollTop(0);   
      $('.cd-header').css('backgroundColor','rgb(147, 18, 70)');
    }

    ngDoCheck() {
      this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"));
    }

    getDashBoardModule(type){
      if(type=="Recommended" && this.userId==-1) {
        this.router.navigate(['login']);
        sessionStorage.setItem('isRecommended','true')
      }

      if(type=="Editor's Pick") {
        type="Editor"
      }

      const inputJson={
        // "Type":type,
        "Type": "Adv",
        "UserId":this.userId
      }
    // console.log(inputJson);
      this.service.GetDashBoardAdvModule(inputJson)
      .subscribe(
        (result:any[])=>{
          this.isLoading=true;
          if(result['Status']=="Success"){

              // this.moduleData=result['DashBoardData'];
              if(result['DashBoardData'].length==0){               
                this.noModules=true;
              } else {
                if(type == 'Free') {
                  for(var i=0 ; i < result['DashBoardData'].length; i++) {
                    if(result['DashBoardData'][i].IsFree == true) {
                      this.moduleData.push(result['DashBoardData'][i])
                    }                  
                  }
                } else {
                  for(var i=0 ; i < result['DashBoardData'].length; i++) {
                    if(result['DashBoardData'][i].IsFree == false) {
                      this.moduleData.push(result['DashBoardData'][i])
                    }                  
                  }
                }
              }
            // console.log(this.moduleData);
              setTimeout(()=>{
                this.isLoading=false;
              },100)



          } else {
            this.service.alert(result['Message'],"error")
              this.isLoading=false;
          }
        },
        (error)=>{
        // console.log(error);
            this.isLoading=false;
        },

      )
    }

    showShareOptions(pvarId,pvarType){
    // console.log(pvarId);
      if(this.moduleId==pvarId){
          this.isShareMenu=!this.isShareMenu;
      }
      else {
          this.isShareMenu=true;
      }
      this.moduleId=pvarId;
      this.type=pvarType;

      this.updateMeta();
    }

    hideShareOptions(pvarId){
      if(this.moduleId==pvarId)
      this.isShareMenu=false;
    }

    goToModule(pvarId,pvarName,isLink,pvarIsFree){
      if(isLink==true){

        if(this.userId!=-1){
        if(localStorage.getItem("planId")=='-1' && pvarIsFree==false){
          const inputJson={
            "ModuleId":pvarId,
            "UserId":this.userId
          }
        // console.log(inputJson);
          this.service.ClickOnPaidModule(inputJson)
          .subscribe(
            (result:any[])=>{
            // console.log(result);
              if(result['Status']=="Success"){

              }
              else{
                this.service.alert(result['Message'],"error");
              }
            },
            (error:Error)=>{
            // console.log(error);
            }
          )

        }

      }

        var name=pvarName.split(' ').join('-');
        this.router.navigate(['module',name,pvarId]);

      } else {
        return false;
      }
    }

    addBookmark(pvarId,status) {
      if(this.userId==-1){
        this.service.alert("Please login to use this feature","error");
        return false;
      } else {
        const inputJson = {
            "ModuleId":pvarId,
            "Status":status,
            "UserId":this.userId
        }

        if(status=="False"){
          inputJson.Status=true
        }
        else if(status=="True"){
          inputJson.Status=false
        }
        // console.log(inputJson);
          this.service.AddBookmark(inputJson)
          .subscribe(
            (result:any[])=>{
              if(result['Status']=="Success"){
                if(inputJson.Status==true)
                this.service.alert("Bookmark added successfully","success");
                else
                this.service.alert("Bookmark removed successfully","success");

              } else {
                this.service.alert(result['Message'],"error");
              }

            },
            (error)=>{
            // console.log(error);
            },
            ()=>{

              this.moduleData=[];
              setTimeout(()=>{

                this.ngOnInit();
              },1000)


            }
          )
      }

    }

    // Harkamal Singh : Method to update meta tag
    updateMeta(){
      this.meta.updateTag({
      content: 'http://happcoach.com/PilotServices/Module/'+this.moduleId+'.html'
      },
      "property='og:url'"
      );
      this.shareUrl="https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
      // this.shareUrl="http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html"
    }

    // Harkamal Singh : Method to share to facebook,twitter,linkedin,g+
    shareToSocial(pvarChoice:number){
      if(pvarChoice==0){ // facebook
          window.open(
            "http://www.facebook.com/sharer/sharer.php?u="+this.shareUrl,
            '_blank' // <- This is what makes it open in a new window.
          );
      }

      if(pvarChoice==1){//twitter
        window.open(
        "https://twitter.com/intent/tweet?url="+this.shareUrl+"&text="+this.title.getTitle(),
        '_blank'
      );
    }
      if(pvarChoice==2){//linkedin
        window.open(
        "https://www.linkedin.com/shareArticle?mini=true&url="+this.shareUrl+"&title="+this.title.getTitle(),
        '_blank'
      )
      }

      if(pvarChoice==3){//google plus
        window.open(
        "https://plus.google.com/share?url="+this.shareUrl,
        '_blank'
      )
      }

    }

    getNumber(rating){
      return Math.trunc(rating);
    }

    sanitize(){
      let url:string="whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
        // let url:string="whatsapp://send?text=http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";
      this.myurl=url;
       let s:SafeUrl=this.sanitizer.bypassSecurityTrustUrl(this.myurl);
       return s;
    }

    shareWhatsApp(){
      window.location.href = "whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
      // window.location.href = "whatsapp://send?text=https://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";
    }

    showActiveModule(pvarId){
       this.home.showActiveModule(pvarId);
       this.service.storageSub.next('change');
    }

    freeActive(){
       this.freeTag=true;
       this.isLink=false;
    }

    freeInactive(){
       this.freeTag=false;
       this.isLink=true;
    }
}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/all-modules/all-modules.component.ts